export const DEFAULT_PAGE_SIZE = 400;
export const DEFAULT_SORT_ORDER = ['name,asc'];
